import {computed} from "vue";
import {getCtlBodyHeight} from "@/gateway-main/common/dataTableUtils";
import StyleUtils from "@/gateway-main/common/styleUtils";

export function useCtlSty(borderConfig,sectionConfig,pId='',appendNum=0){

  /**
   * 获取表格显示区域高度
   */
  const ctlTableBodySty= computed(() => {
    const sty = {};
    let height=getCtlBodyHeight(borderConfig) - 44;

    if(unref(sectionConfig).paginFlag===false){
      height=height+40
    }
    sty["height"] = StyleUtils.getCharWidthOrHeight(height, borderConfig, 0) + "px";
    return sty;
  });

  /**
   * 获取表格 的滚动高度
   */
  const scrollConfig = computed(() => {
    let height=getCtlBodyHeight(borderConfig) - 134;
    //如果存在边框
    if(unref(borderConfig)["name"]==="borderHasTitle"){
      height=height - 60;
    }
    //如果没有分页组件
    if(unref(sectionConfig).paginFlag===false){
      height=height+40
    }
    return {y:height};
  });

  /**
   * 计算宽高
   */
  const commonCtlSty = computed(() => {
    let sty = {};
    let ctlHeight = 300;
    let height = borderConfig.value.height;
    if("gateway-main"===pId){
      if((height+'').indexOf("%")>0||(height+'').indexOf("auto")>=0){
        sty["height"] = height;
      }else{
        sty["height"] = parseFloat(height) + "px";
      }
    }else{
      if((height+'').indexOf("%")>0||(height+'').indexOf("auto")>=0){
        sty["height"] = `calc(${height} - ${StyleUtils.getCharWidthOrHeight(0, borderConfig, 0)})`
      }else{
        sty["height"] = StyleUtils.getCharWidthOrHeight(ctlHeight, borderConfig, appendNum) + "px";
      }
    }
    return sty;
  })


  return {
    commonCtlSty,
    scrollConfig,
    ctlTableBodySty
  }
}
